import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  ValidationErrors,
  FormArray,
} from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { SystemsInventoryRequestService } from "../../../service/systems-inventory-request/systems-inventory-request.service";
import { SystemsInventoryRequest } from "../../../class/systems-inventory-request";
import { TranslateService } from "@ngx-translate/core";
import { Message } from "primeng/primeng";
import { UploadFilesService } from "../../../service/upload-files/upload-files.service";
import { config } from "../../../../../../environments/config";
import { NotificationsService } from "../../../../../theme/services/notifications/notifications.service";
import { HasPermissionService } from "../../../service/has-permission/has-permission.service";
import { SimpleChanges } from "@angular/core/public_api";
import { formatDate } from "../../../../../theme/functions/formatDate.function";
import { calendarES } from "../../../../../theme/functions/calendarES";

@Component({
  selector: "app-new-systems-inventory-request",
  templateUrl: "./new-systems-inventory-request.component.html",
  styleUrls: ["./new-systems-inventory-request.component.scss"],
})
export class NewSystemsInventoryRequestComponent implements OnInit, OnChanges {
  @Output() msg: EventEmitter<object> = new EventEmitter<object>();
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() verification: boolean;
  @Input() gestionSac: any;
  @Input() subPagePath: string;

  public promiseForm: Promise<any>;
  public form: FormGroup;
  public documents_assigned: FormArray;
  public apiUrl = config.API_ROOT;
  public msgs: Message[];
  public edit?: SystemsInventoryRequest;
  public doRequest: number = 0;
  private id: number;
  public equipmentTypeOptions: any[];
  public equipmentBrandOptions: any[];
  public equipmentStatusOptions: any[];
  public antivirusOptions: any[];
  public officeOptions: any[];
  public operativeSystemOptions: any[];
  public diskOptions: any[];
  public diskTypeOptions: any[];
  public ramOptions: any[];
  public ramTypeOptions: any[];
  public fileUrl: string[] = [];
  public loading_upload: boolean;
  public uploadedAttachment: any[] = [];
  public prewiewFileAttachment: any[] = [];
  public promiseAttachment: Promise<any>;
  public messageLifeUtil: string = "";
  public statusLifeUtil: string = "";
  public classState: string = "";
  public editForm: any[] = [];
  public es: any;

  constructor(
    public fb: FormBuilder,
    public systemsInventoryRequestService: SystemsInventoryRequestService,
    public translate: TranslateService,
    private notificationsService: NotificationsService,
    public uploadFilesService: UploadFilesService,
    public hasPermissionService: HasPermissionService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.es = calendarES();

    this.equipmentTypeOptions = [
      { label: "Computador de escritorio", value: "Computador de escritorio" },
      { label: "Computador portátil", value: "Computador portátil" },
      { label: "Celular", value: "Celular" },
      { label: "Impresora", value: "Impresora" },
      { label: "Otro", value: "Otro" },
    ];

    this.equipmentBrandOptions = [
      { label: "Asus", value: "Asus" },
      { label: "Hewlett-Packard (HP)", value: "Hewlett-Packard (HP)" },
      { label: "Lenovo", value: "Lenovo" },
      { label: "Epson", value: "Epson" },
      { label: "LG", value: "LG" },
      { label: "Genius", value: "Genius" },
      { label: "Otro", value: "Otro" },
    ];

    this.equipmentStatusOptions = [
      { id: 1, label: "Nuevo", value: "Nuevo" },
      { id: 2, label: "Usado sin defectos", value: "Usado sin defectos" },
      { id: 3, label: "Usado con defectos", value: "Usado con defectos" },
      { id: 4, label: "Dañado", value: "Dañado" },
      { id: 5, label: "Vendido", value: "Vendido" },
      { id: 6, label: "Donado", value: "Donado" },
      { id: 7, label: "Robado", value: "Robado" },
    ];

    this.antivirusOptions = [
      { label: "Sophos", value: "Sophos" },
      { label: "Norton", value: "Norton" },
      { label: "Kaspersky", value: "Kaspersky" },
      { label: "McAfee", value: "McAfee" },
      { label: "Otro", value: "Otro" },
      { label: "No tiene", value: "No tiene" },
      { label: "No aplica", value: "No aplica" },
    ];

    this.officeOptions = [
      { label: "Microsoft Office 2010", value: "Microsoft Office 2010" },
      { label: "Microsoft Office 2013", value: "Microsoft Office 2013" },
      { label: "Microsoft Office 2016", value: "Microsoft Office 2016" },
      { label: "Microsoft Office 2019", value: "Microsoft Office 2019" },
      { label: "Microsoft Office 2021", value: "Microsoft Office 2021" },
      { label: "Office 365", value: "Office 365" },
      { label: "Libre Office", value: "Libre Office" },
      { label: "Otro", value: "Otro" },
      { label: "No tiene", value: "No tiene" },
      { label: "No aplica", value: "No aplica" },
    ];

    this.operativeSystemOptions = [
      { label: "Windows 8", value: "Windows 8" },
      { label: "Windows 10", value: "Windows 10" },
      { label: "Windows 11", value: "Windows 11" },
      { label: "Windows 12", value: "Windows 12" },
      { label: "Mac OS", value: "Mac OS" },
      { label: "Linux Ubuntu", value: "Linux Ubuntu" },
      { label: "Linux Kubuntu", value: "Linux Kubuntu" },
      { label: "Linux Debian", value: "Linux Debian" },
      { label: "Linux Fedora", value: "Linux Fedora" },
      { label: "Linux Gentoo", value: "Linux Gentoo" },
      { label: "iOS", value: "iOS" },
      { label: "Android", value: "Android" },
      { label: "MIUI", value: "MIUI" },
      { label: "Otro", value: "Otro" },
      { label: "No tiene", value: "No tiene" },
      { label: "No aplica", value: "No aplica" },
    ];

    this.diskOptions = [
      { label: "2 GB", value: "2 GB" },
      { label: "4 GB", value: "4 GB" },
      { label: "8 GB", value: "8 GB" },
      { label: "12 GB", value: "12 GB" },
      { label: "16 GB", value: "16 GB" },
      { label: "32 GB", value: "32 GB" },
      { label: "64 GB", value: "64 GB" },
      { label: "128 GB", value: "128 GB" },
      { label: "256 GB", value: "256 GB" },
      { label: "564 GB", value: "564 GB" },
      { label: "1 TB", value: "1 TB" },
      { label: "2 TB", value: "2 TB" },
      { label: "3 TB", value: "3 TB" },
      { label: "Otro", value: "Otro" },
      { label: "No tiene", value: "No tiene" },
      { label: "No aplica", value: "No aplica" },
    ];

    this.diskTypeOptions = [
      { label: "HDD", value: "HDD" },
      { label: "SSD", value: "SSD" },
      { label: "Híbrido (HDD + SSD)", value: "Híbrido (HDD + SSD)" },
      { label: "UFS", value: "UFS" },
      { label: "Otro", value: "Otro" },
      { label: "No aplica", value: "No aplica" },
    ];

    this.ramOptions = [
      { label: "1 GB", value: "1 GB" },
      { label: "2 GB", value: "2 GB" },
      { label: "4 GB", value: "4 GB" },
      { label: "6 GB", value: "6 GB" },
      { label: "8 GB", value: "8 GB" },
      { label: "12 GB", value: "12 GB" },
      { label: "16 GB", value: "16 GB" },
      { label: "32 GB", value: "32 GB" },
      { label: "64 GB", value: "64 GB" },
      { label: "128 GB", value: "128 GB" },
      { label: "256 GB", value: "256 GB" },
      { label: "564 GB", value: "564 GB" },
      { label: "1 TB", value: "1 TB" },
      { label: "Otro", value: "Otro" },
      { label: "No tiene", value: "No tiene" },
      { label: "No aplica", value: "No aplica" },
    ];

    this.ramTypeOptions = [
      { label: "SDR SDRAM", value: "SDR SDRAM" },
      { label: "RDRAM", value: "RDRAM" },
      { label: "DDR SDRAM", value: "DDR SDRAM" },
      { label: "DDR2 SDRAM", value: "DDR2 SDRAM" },
      { label: "DDR3 SDRAM", value: "DDR3 SDRAM" },
      { label: "DDR4 SDRAM", value: "DDR4 SDRAM" },
      { label: "DDR5 SDRAM", value: "DDR5 SDRAM" },
      { label: "GDDR6 SDRAM", value: "GDDR6 SDRAM" },
      { label: "Otro", value: "Otro" },
      { label: "No aplica", value: "No aplica" },
    ];
  }

  createForm(data: any = null) {
    data = data || {
      id: undefined,
      equipment_type: "",
      equipment_type_other: null,
      equipment_brand: "",
      equipment_brand_other: null,
      equipment_name: null,
      equipment_serial: null,
      observations: null,
      hdd_ssd: "",
      hdd_ssd_type: "",
      ram_memory: "",
      ram_memory_type: "",
      operative_system: "",
      office_tools: "",
      processor: null,
      purchase_date: null,
      antivirus: "",
      antivirus_expiration_date: null,
      supplier: null,
      price: null,
      invoice_number: null,
      fixed_asset: null,
    };
    this.form = this.fb.group({
      id: new FormControl(data.id),
      equipment_type: new FormControl(
        data.equipment_type,
        Validators.compose([Validators.required])
      ),
      equipment_type_other: new FormControl(data.equipment_type_other),
      equipment_brand: new FormControl(
        data.equipment_brand,
        Validators.compose([Validators.required])
      ),
      equipment_brand_other: new FormControl(data.equipment_brand_other),
      equipment_name: new FormControl(
        data.equipment_name,
        Validators.compose([Validators.required, Validators.minLength(1)])
      ),
      equipment_serial: new FormControl(
        data.equipment_serial,
        Validators.compose([Validators.required, Validators.minLength(1)])
      ),
      observations: new FormControl(data.observations),
      hdd_ssd: new FormControl(
        data.hdd_ssd,
        Validators.compose([Validators.required])
      ),
      hdd_ssd_type: new FormControl(
        data.hdd_ssd_type,
        Validators.compose([Validators.required])
      ),
      ram_memory: new FormControl(
        data.ram_memory,
        Validators.compose([Validators.required])
      ),
      ram_memory_type: new FormControl(
        data.ram_memory_type,
        Validators.compose([Validators.required])
      ),
      operative_system: new FormControl(
        data.operative_system,
        Validators.compose([Validators.required])
      ),
      office_tools: new FormControl(
        data.office_tools,
        Validators.compose([Validators.required])
      ),
      processor: new FormControl(data.processor),
      purchase_date: new FormControl(
        data.purchase_date ? new Date(data.purchase_date) : null
      ),
      antivirus: new FormControl(
        data.antivirus,
        Validators.compose([Validators.required])
      ),
      antivirus_expiration_date: new FormControl(
        data.antivirus_expiration_date
          ? new Date(data.antivirus_expiration_date)
          : null
      ),
      supplier: new FormControl(data.supplier),
      price: new FormControl(data.price),
      invoice_number: new FormControl(data.invoice_number),
      fixed_asset: new FormControl(
        data.fixed_asset,
        Validators.compose([Validators.required, Validators.minLength(3)])
      ),

      equipment_tracking: this.fb.array([]),
    });
  }

  ngOnInit() {
    this.id = +this.route.snapshot.paramMap.get("id");
    if (this.id !== 0 && this.id !== undefined) {
      var promiseLoc = this.systemsInventoryRequestService
        .infoSystemsInventoryRequest(this.id)
        .toPromise()
        .then(
          (response) => {
            this.edit = response.json();
            this.createForm(this.edit);
            this.listFieldsFormsArray(
              this.equipment_tracking,
              this.edit.equipment_tracking,
              "equipment_tracking"
            );
            const resultLifeUtil =
              this.systemsInventoryRequestService.calculateUtilLife(
                this.edit.purchase_date
              );
            this.messageLifeUtil = resultLifeUtil.message;
            this.statusLifeUtil = resultLifeUtil.state;
            this.classState = resultLifeUtil.class;
            this.doRequest = 1;
          },
          (error) => {
            this.notificationsService.growlNotify(
              "error",
              "ID " + this.id + " no encontrado"
            );
            this.router.navigateByUrl(
              "/pages/innovation/systems-inventory-requests"
            );
          }
        );
    } else {
      this.createForm(this.edit);
      this.doRequest = 1;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {}

  public cancelSystemsInventoryRequest() {
    this.form.reset();
    this.close.emit(true);
  }

  public newSystemsInventoryRequest(values) {
    values.activated = 0;
    if (this.id === 0) values.activated = 1;

    values.purchase_date = formatDate(values.purchase_date);
    values.antivirus_expiration_date = formatDate(
      values.antivirus_expiration_date
    );
    values.equipment_type.value == "Otro" ? values.equipment_type_other : null;
    values.equipment_brand.value == "Otro"
      ? values.equipment_brand_other
      : null;
    values.equipment_type.value == "Computador de escritorio" ||
    values.equipment_type.value == "Computador portátil"
      ? values.office_tools
      : null;
    values.price == null || values.price == "" ? 0 : values.price;

    values.id = values.id == null ? undefined : values.id;

    if (values.equipment_tracking) {
      for (let i = 0; i < values.equipment_tracking.length; i++) {
        values.equipment_tracking[i].assigned_to_by_id =
          values.equipment_tracking[i].assigned_to_by_id.id;
        values.equipment_tracking[i].assigned_date = formatDate(
          values.equipment_tracking[i].assigned_date
        );
        values.equipment_tracking[i].destination_id =
          values.equipment_tracking[i].destination_id.id;
        console.log(values.equipment_tracking[i].documents_assigned.File);

        if (values.equipment_tracking[i].return_date)
          values.equipment_tracking[i].return_date = formatDate(
            values.equipment_tracking[i].return_date
          );
      }
    }

    if (values && this.form.valid) {
      this.promiseSubmit(values);
    }
  }

  public promiseSubmit(values) {
    const promise = this.edit
      ? this.systemsInventoryRequestService.updateSystemsInventoryRequest(
          this.edit.id,
          values
        )
      : this.systemsInventoryRequestService.newSystemsInventoryRequest(values);
    this.promiseForm = promise.toPromise().then(
      (response) => {
        this.translate.get("saved").subscribe((res: string) => {
          this.notificationsService.growlNotify("success", res);
          this.edit = response.json();
          // this.msg.emit( { severity: 'success', summary: res  } );
          this.close.emit(true);
          this.form.reset();
        });
        this.router.navigateByUrl(
          "/pages/innovation/systems-inventory-requests"
        );
      },
      (error) => {
        let msg = "";
        this.translate
          .get(JSON.parse(error._body).errors[0].detail)
          .subscribe((res1: string) => {
            this.translate
              .get(JSON.parse(error._body).errors[1].detail)
              .subscribe((res2: string) => {
                JSON.parse(error._body).errors.forEach((element) => {
                  if (element.source) {
                    if (element.source.pointer) {
                      this.translate
                        .get(element.source.pointer)
                        .subscribe((res3: string) => {
                          msg = msg + res3 + ", ";
                        });
                    }
                  }
                });
                this.notificationsService.growlNotify(
                  "error",
                  res1 + " " + res2 + ": " + msg
                );
                // this.msg.emit( { severity: 'error', summary: 'Error' } );
              });
          });
      }
    );
  }

  public getStatusObject(eventObjetc, nameObject: string) {
    var status = false;
    if (eventObjetc == nameObject) status = true;

    return status;
  }

  getFormValidationErrors(form) {
    let value = "";
    Object.keys(form.controls).forEach((key) => {
      const controlErrors: ValidationErrors = form.get(key).errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach((keyError) => {
          value =
            "Key control: " +
            key +
            ", keyError: " +
            keyError +
            ", err value: " +
            controlErrors[keyError];
        });
      }
    });
    return value;
  }

  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }

  public hasRole(rol) {
    var r: boolean = false;
    var role = JSON.parse(localStorage.getItem("profile")).roles[0].id;
    if (role == rol) {
      r = true;
    }
    return r;
  }

  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  };

  deleteEquipmentTracking(equipmentTrackingIndex: number) {
    this.equipment_tracking.removeAt(equipmentTrackingIndex);
  }

  listFieldsFormsArray(
    formArrayLoc: FormArray,
    data: any[],
    execfunction: string
  ) {
    this.clearFormArray(formArrayLoc);

    if (data.length > 0) {
      data.forEach((element) => {
        const tracking = this.addEquipmentTracking(element);

        // if (element.documents_assigned && element.documents_assigned.length > 0) {
        //   element.documents_assigned.forEach(doc => {
        //     this.addFile(tracking, doc);
        //   });
        // }
      });
    }
  }

  get equipment_tracking() {
    return this.form.controls["equipment_tracking"] as FormArray;
  }

  addEquipmentTracking(data: any = null) {
    data = data || {
      id: undefined,
      assigned_to_by_id: null,
      venue_id: null,
      equipment_status: "",
      equipment_observations: "",
      assigned_date: null,
      return_date: null,
      destination_id: null,
      documents_assigned: this.fb.array([]),
    };

    const documentsAssignedArray = this.fb.array(
      Array.isArray(data.documents_assigned)
        ? data.documents_assigned.map((document) =>
            this.fb.group({
              id: [document.id],
              attachment: [document.attachment],
            })
          )
        : []
    );

    const equipment_trackingForm = this.fb.group({
      id: [data.id],
      assigned_to_by_id: [
        data.assigned_to_by_id,
        Validators.compose([Validators.required]),
      ],
      venue_id: [
        data.venue_id,
        Validators.compose([Validators.required, Validators.minLength(1)]),
      ],
      equipment_status: [
        data.equipment_status,
        Validators.compose([Validators.required, Validators.minLength(1)]),
      ],
      equipment_observations: [
        data.equipment_observations,
        Validators.compose([Validators.required, Validators.minLength(2)]),
      ],
      assigned_date: [
        data.assigned_date ? new Date(data.assigned_date) : null,
        Validators.compose([Validators.required]),
      ],
      return_date: [data.return_date ? new Date(data.return_date) : null],
      destination_id: [
        data.destination_id,
        Validators.compose([Validators.required]),
      ],
      documents_assigned: documentsAssignedArray,
    });
    const equipment_trackingArray = this.form.get(
      "equipment_trackingForm"
    ) as FormArray;
    this.editForm.push(data);
    this.equipment_tracking.push(equipment_trackingForm);
  }

  public promiseSubmitDocuments(equipment_tracking_id: number, formArray) {
    const files = formArray.value
      .map((document: any) => (document.file ? document.file : null))
      .filter((file) => file !== null);
    const promise = this.uploadFilesService
      .updateAttachmentAssignedDocument(files, equipment_tracking_id)
      .toPromise();

    promise.then(
      (response) => {
        this.notificationsService.growlNotify(
          "success",
          "Archivos subidos correctamente"
        );
      },
      (error) => {
        this.notificationsService.growlNotify(
          "error",
          "Error al subir los archivos"
        );
      }
    );
  }

  public onDocumentsAssigned(event: any, equipment_tracking_id: number) {
    const formArray = this.getDocumentsAssignedFormArray(equipment_tracking_id);

    Array.from(event.target.files).forEach((file: File) => {
      formArray.push(
        this.fb.group({
          file: [file, Validators.required],
          attachment: [file.name],
        })
      );
    });
    this.promiseSubmitDocuments(equipment_tracking_id, formArray);
  }

  getDocumentsAssignedFormArray(equipment_tracking_id: number): FormArray {
    const equipmentTrackingForm = this.equipment_tracking.controls.find(
      (control) => control.value.id === equipment_tracking_id
    );

    return equipmentTrackingForm.get("documents_assigned") as FormArray;
  }

  public gotoDocument(id) {
    window.open(
      this.apiUrl +
        "/systems-inventory/" +
        id +
        "/attachment" +
        "?token=" +
        localStorage.getItem("token"),
      "_blank"
    );
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/systems-inventory-requests/new-systems-inventory-request/new-systems-inventory-request.component.ts